import { list, find } from 'src/repositories/debtor.repository';
import {
    fetchActions,
    fetchClientOperatorActions,
    inactive,
    finish,
    activate,
} from 'src/repositories/debt.repository';

export const LOAD_DEBTORS_REQUEST = 'LOAD_DEBTORS_REQUEST';
export const LOAD_DEBTORS_SUCCESS = 'LOAD_DEBTORS_SUCCESS';
export const LOAD_DEBTORS_ERROR = 'LOAD_DEBTORS_ERROR';

export const loadDebtors = params => (dispatch) => {
    dispatch({ type: LOAD_DEBTORS_REQUEST, payload: null });

    return list(params)
        .then(res => dispatch({ type: LOAD_DEBTORS_SUCCESS, payload: res.data }))
        .catch((e) => {
            dispatch({ type: LOAD_DEBTORS_ERROR, payload: e });
            throw e;
        });
};

export const LOAD_DEBTOR_REQUEST = 'LOAD_DEBTOR_REQUEST';
export const LOAD_DEBTOR_SUCCESS = 'LOAD_DEBTOR_SUCCESS';
export const LOAD_DEBTOR_ERROR = 'LOAD_DEBTOR_ERROR';
export const findDebtor = pkDebtor => (dispatch) => {
    dispatch({ type: LOAD_DEBTOR_REQUEST, payload: null });
    return find(pkDebtor)
        .then(res => dispatch({
            type: LOAD_DEBTOR_SUCCESS,
            payload: res.data,
        }))
        .catch((e) => {
            dispatch({ type: LOAD_DEBTOR_ERROR, payload: e });
            throw e;
        });
};

export const REQUESTING_DEBT_ACTIONS = 'REQUESTING_DEBT_ACTIONS';
export const FETCHED_DEBT_ACTIONS = 'FETCHED_DEBT_ACTIONS';
export const FETCH_DEBT_ACTIONS_ERROR = 'FETCH_DEBT_ACTIONS_ERROR';
export const loadDebtActions = (debt, type, page = 1) => async (dispatch) => {
    dispatch({ type: REQUESTING_DEBT_ACTIONS, payload: null });
    let operatorActions;
    let systemActions;
    const result = {};
    if (type === 'operator') {
        operatorActions = await fetchClientOperatorActions(debt, page);
        result.operator = operatorActions.data;
    } else if (type === 'system') {
        systemActions = await fetchActions(debt, page);
        result.system = systemActions.data;
    }

    dispatch({
        type: FETCHED_DEBT_ACTIONS,
        payload: result,
    });

};

export const ACTIVATE_DEBT_REQUEST = 'ACTIVATE_DEBT_REQUEST';
export const ACTIVATE_DEBT_SUCCESS = 'ACTIVATE_DEBT_SUCCESS';
export const ACTIVATE_DEBT_ERROR = 'ACTIVATE_DEBT_ERROR';
export const activateDebt = pkDebt => (dispatch) => {
    dispatch({ type: ACTIVATE_DEBT_REQUEST, payload: null });
    return activate(pkDebt)
        .then(res => dispatch({
            type: ACTIVATE_DEBT_SUCCESS,
            payload: res.data,
        }))
        .catch((err) => {
            dispatch({ type: ACTIVATE_DEBT_ERROR, payload: null });
            throw err;
        });
};


export const INACTIVE_DEBT_REQUEST = 'INACTIVE_DEBT_REQUEST';
export const INACTIVE_DEBT_SUCCESS = 'INACTIVE_DEBT_SUCCESS';
export const INACTIVE_DEBT_ERROR = 'INACTIVE_DEBT_ERROR';
export const inactiveDebt = pkDebt => (dispatch) => {
    dispatch({ type: INACTIVE_DEBT_REQUEST, payload: null });
    return inactive(pkDebt)
        .then(res => dispatch({
            type: INACTIVE_DEBT_SUCCESS,
            payload: res.data,
        }))
        .catch((err) => {
            dispatch({ type: INACTIVE_DEBT_ERROR, payload: null });
            throw err;
        });
};

export const FINISH_DEBT_REQUEST = 'FINISH_DEBT_REQUEST';
export const FINISH_DEBT_SUCCESS = 'FINISH_DEBT_SUCCESS';
export const FINISH_DEBT_ERROR = 'FINISH_DEBT_ERROR';
export const finishDebt = pkDebt => (dispatch) => {
    dispatch({ type: FINISH_DEBT_REQUEST, payload: null });
    return finish(pkDebt)
        .then(res => dispatch({
            type: FINISH_DEBT_SUCCESS,
            payload: res.data,
        }))
        .catch((err) => {
            dispatch({ type: FINISH_DEBT_ERROR, payload: null });
            throw err;
        });
};
